import Card from '@/components/common/ui/Card';

import { Globe, Smartphone, Palette, Zap, Bell, ShieldCheck } from 'lucide-react';

const plans = [
    {
        title: "Responsive Web Applications",
        description:
            "Build fast, scalable web apps that deliver seamless experiences across all browsers and devices, tailored to your business needs.",
        icon: Globe,
    },
    {
        title: "Cross-Platform Mobile Apps",
        description:
            "Launch powerful iOS and Android apps from a single codebase, reducing time-to-market without compromising on performance.",
        icon: Smartphone,
    },
    {
        title: "UI/UX Design & Prototyping",
        description:
            "Craft intuitive, visually stunning interfaces backed by user research and rapid prototyping to maximize engagement and retention.",
        icon: Palette,
    },
    {
        title: "Performance Optimization",
        description:
            "Supercharge your app's speed and responsiveness with advanced caching, lazy loading, and code-splitting strategies.",
        icon: Zap,
    },
    {
        title: "Push Notifications & Engagement",
        description:
            "Re-engage users with targeted push notifications, in-app messaging, and deep linking to drive conversions and retention.",
        icon: Bell,
    },
    {
        title: "App Security & Compliance",
        description:
            "Safeguard your web and mobile apps with end-to-end encryption, secure authentication, and compliance with GDPR and industry standards.",
        icon: ShieldCheck,
    }
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-6">
            <div className="text-center">
                <h3 className="text-xl md:text-3xl font-bold text-white leading-tight mb-12">
                    Empowering businesses through seamless technology
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}